import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid';
import { twJoin } from 'tailwind-merge';

export type SelectOption = {
  label: string;
  value: string;
};

type Props = {
  name: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  selected: SelectOption | undefined;
};

export function SelectInput({ selected, onChange, options }: Props) {
  return (
    <Listbox value={selected?.value} onChange={onChange}>
      <div className="relative w-36">
        <ListboxButton className="relative w-full cursor-pointer bg-white h-10 pl-3 pr-10 text-left text-zinc-900 ring-1 ring-zinc-300 focus:border-zinc-300 focus:outline-none focus:ring-primary-300 focus:ring-2 sm:text-sm sm:leading-6">
          <span className="block truncate">{selected?.label}</span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronDownIcon className="size-5 text-gray-400" aria-hidden="true" />
          </span>
        </ListboxButton>

        <ListboxOptions
          transition
          className={twJoin(
            'absolute z-10 mt-1 max-h-60 w-full overflow-auto bg-white py-1 text-base',
            'shadow-lg ring-1 ring-zinc-100 focus:outline-none sm:text-sm',
            'origin-top transition duration-200 ease-out',
            'data-closed:scale-95 data-closed:opacity-0',
          )}
        >
          {options.map((option) => (
            <ListboxOption
              key={option.value}
              value={option.value}
              className={twJoin(
                'data-focus:bg-primary-50 group text-gray-900',
                'relative cursor-pointer select-none py-2 pl-3 pr-9',
              )}
            >
              <>
                <span
                  className={twJoin(
                    'group-data-selected:font-semibold font-normal',
                    'block truncate text-left',
                  )}
                >
                  {option.label}
                </span>

                <span className="absolute flex inset-y-0 right-0 invisible items-center pr-4 group-data-selected:visible">
                  <CheckIcon className="size-5" aria-hidden="true" />
                </span>
              </>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  );
}
